import toItineraryPredicate from '../../../Filters/queries/toItineraryPredicate';
import { calculateHour } from './DepartureTimeLegCollector';

const predicate = toItineraryPredicate(({ min, max }) => ({ sections }) => {
  const hour = calculateHour(sections);
  return hour >= min && hour < max;
});

export default predicate;
